"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticPath = void 0;
const config_1 = __importDefault(require("../config"));
const staticPath = (path) => `${config_1.default.staticPath}${path}`;
exports.staticPath = staticPath;
exports.default = {};
